'use client';

import React from 'react';
import { Plus } from 'lucide-react';

interface AddRateFABProps {
  onOpen?: () => void;
}

export default function AddRateFAB({ onOpen }: AddRateFABProps) {
  return (
    <div className="fab-add-rate">
      {/* Pulse ring behind FAB */}
      <div
        className="absolute inset-0 rounded-full fab-pulse"
        style={{
          background: 'rgba(0, 86, 210, 0.18)',
          transform: 'scale(1.35)',
          zIndex: -1,
        }}
      />
      <button
        onClick={onOpen}
        aria-label="Add land rate"
        className="
          flex items-center gap-2 bg-primary text-primary-foreground
          rounded-full px-5 py-3.5 sm:px-6 shadow-fab
          font-semibold text-sm tracking-wide
          hover:bg-accent transition-all duration-150
          active:scale-95 active:shadow-none
          whitespace-nowrap min-h-[48px]
        "
      >
        <Plus size={17} strokeWidth={2.5} />
        Add Rate
      </button>
    </div>
  );
}